export default __webpack_public_path__ + "836238bbf5cf7e2426f9ab42b90b2af9.png";